import Vue from 'vue'
import App from './App.vue'
import router from './router'
import anime from 'animejs'
import imagesLoaded from 'vue-images-loaded'
import inViewportDirective from 'vue-in-viewport-directive'

Vue.config.productionTip = false
Vue.prototype.$anime = anime

inViewportDirective.defaults.margin = '-20px 0px'
inViewportDirective.defaults.throttle = 0.2

Vue.directive('imagesLoaded', imagesLoaded)
Vue.directive('in-viewport', inViewportDirective)

Vue.filter('leftPad',  function (value) {
  return ('00'+value).slice(-2);
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
